var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 108.7",
    style: {
      enableBackground: "new 0 0 122.88 108.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,95.27V56.59h17.4c7.38,1.32,14.75,5.32,22.13,9.96h13.51c6.12,0.37,9.33,6.57,3.37,10.64 c-4.74,3.48-10.99,3.28-17.4,2.7c-4.42-0.22-4.61,5.72,0,5.74c1.6,0.13,3.34-0.25,4.86-0.25c7.99-0.01,14.58-1.54,18.62-7.86 l2.02-4.72l20.11-9.96c10.06-3.31,17.21,7.21,9.8,14.53c-14.56,10.59-29.49,19.31-44.77,26.35c-11.1,6.75-22.19,6.52-33.28,0 L25.4,95.27L25.4,95.27L25.4,95.27z M64.35,0c-2.94,0-5.46,1.04-7.55,3.11c-2.1,2.07-3.11,4.59-3.11,7.55v23.42 c0,2.97,1.04,5.48,3.11,7.55c2.07,2.07,4.59,3.11,7.55,3.11h8.76c-1.37,5.25-2.8,9.04-6.96,12.75c7.85-2.04,14.65-6.19,19.53-12.74 h7.05c2.94,0,5.46-1.06,7.55-3.11c2.09-2.07,3.11-4.59,3.11-7.55V10.66c0-2.94-1.04-5.46-3.11-7.55C98.21,1.01,95.7,0,92.73,0 C83.27,0,73.81,0,64.35,0L64.35,0z M81.59,27.81h-7.25c0-1.25-0.02-2.54,0.42-3.73c0.28-0.78,0.7-1.47,1.25-2.11 c0.55-0.64,1.8-1.76,3.73-3.36c1.03-0.84,1.54-1.61,1.54-2.31c0-0.7-0.21-1.24-0.62-1.64c-0.42-0.38-1.04-0.58-1.88-0.58 c-0.91,0-1.65,0.3-2.24,0.9c-0.59,0.59-0.97,1.64-1.13,3.13L68,17.19c0.26-2.72,1.24-4.91,2.97-6.58c1.72-1.66,4.37-2.49,7.94-2.49 c2.78,0,5.01,0.58,6.72,1.73c2.31,1.57,3.47,3.66,3.47,6.26c0,1.08-0.3,2.13-0.9,3.13c-0.59,1-1.82,2.24-3.66,3.68 c-1.28,1.02-2.1,1.84-2.44,2.46C81.7,26.12,81.59,27,81.59,27.81L81.59,27.81z M81.86,30.44v4.78h-7.77v-4.78H81.86L81.86,30.44z M0,52.87h20.16v46.29H0V52.87L0,52.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryIcon);
export default __webpack_public_path__ + "static/media/query-icon.a95a667d6d8d27075b628d3bbb989f7f.svg";
export { ForwardRef as ReactComponent };